import React, { useEffect, useRef, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import BrandLogo from './components/BrandLogo';
import { playIntroSound } from './utils/introAudio';

const NetflixTitle = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [needsClickToStart, setNeedsClickToStart] = useState(false);
  const navigate = useNavigate();
  const audioRef = useRef<HTMLAudioElement>(null);
  const hasStartedRef = useRef(false);

  const attemptPlay = async () => {
    const el = audioRef.current;
    let played = false;

    if (el) {
      el.volume = 1;
      el.muted = false;
      try {
        await el.play();
        played = true;
      } catch {
        played = await playIntroSound();
      }
    } else {
      played = await playIntroSound();
    }

    if (played) {
      setNeedsClickToStart(false);
    } else {
      setNeedsClickToStart(true);
    }
  };

  useEffect(() => {
    if (hasStartedRef.current) return;
    hasStartedRef.current = true;

    setIsAnimating(true);
    attemptPlay();

    const retryDelays = [50, 150, 300, 600, 1200];
    const timers = retryDelays.map((delay) =>
      window.setTimeout(() => {
        attemptPlay();
      }, delay)
    );

    return () => timers.forEach((id) => window.clearTimeout(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isAnimating) return;

    const timer = window.setTimeout(() => {
      navigate('/browse');
    }, 4000);

    return () => window.clearTimeout(timer);
  }, [isAnimating, navigate]);

  const handleContainerClick = () => {
    if (needsClickToStart) {
      attemptPlay();
    }
  };

  return (
    <div className="netflix-container" onClick={handleContainerClick}>
      <audio ref={audioRef} src={netflixSound} preload="auto" autoPlay playsInline />
      <BrandLogo variant="intro" className={`netflix-logo ${isAnimating ? 'animate' : ''}`} />
      {needsClickToStart && (
        <p className="sound-hint">Click to enable sound</p>
      )}
    </div>
  );
};

export default NetflixTitle;
